import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import { get } from "../../../../utils/api";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import PurchaseGoodsView from "../../PurchaseGoodsView";

const GoodsService = () => {
  const approvalUrl = "/scope3/emission/apporveOrReject";

  const { user } = useUser();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [filter, setFilter] = useState({
    typeOfActivity: "",
    categoryType: "",
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        facilityList: selectedFacility.join(","),
        page,
        limit: 10,
      }).toString();

      const response = await get(
        `/scope3/emission/apporevelist?${queryParams}`
      );
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility]);

  const fetchFilter = async () => {
    try {
      const response = await get(`/scope3/emission/filter`);
      setFilter({
        typeOfActivity: response.data?.data?.typeOfActivity,
        categoryType: response.data?.data?.categoryType,
      });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchFilter();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const heading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Purchased Month",
    },
    // {
    //   title: "Vendor",
    //   key: "purchases",
    // },
    // {
    //   title: "Type of Activity",
    //   key: "typeOfActivity",
    // },
    {
      title: "Category Type",
      key: "categoryType",
    },
    {
      title: "Name of Activity",
      key: "activityName",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const viewheaders = [
    {
      key: "consumptionPeriod",
      title: "Consumption Period",
      render: (data) =>
        data?.consumptionPeriod?.month && data?.consumptionPeriod?.year
          ? `${data.consumptionPeriod.month}/${data.consumptionPeriod.year}`
          : "-",
    },
    { key: "purchaseVendor", title: "Purchase Vendor" },
    { key: "categoryType", title: "Category Type" },
    { key: "activityName", title: "Name of Activity" },
    { key: "typeOfActivity", title: "Type of Activity" },
    {
      key: "amountSpend",
      title: "Amount Spent",
      render: (data) =>
        data?.amountSpend?.value
          ? `${data.amountSpend.value} ${data.amountSpend.currency || "USD"}`
          : "-",
    },
    {
      key: "quantityBought",
      title: "Quantity Bought",
      render: (data) =>
        data?.quantityBought?.value
          ? `${data.quantityBought.value} ${data.quantityBought.unit || "Kg"}`
          : "-",
    },
    { key: "remark", title: "Remarks" },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Type of Activity",
      type: "option",
      key: "origin",
      value: filter.typeOfActivity ? filter.typeOfActivity : [],
    },
    {
      title: "Category Type",
      type: "option",
      key: "destination",
      value: filter.categoryType ? filter.categoryType : [],
    },
  ];

  const toggleData = [];
  const fetchDataCallback = async () => {
    await fetchData();
  };
  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {/* <Unauthorized requiredModule="Documentation"> */}
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData: toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
        }}
        heading={"Purchased Goods and Services"}
      />
      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={heading}
        columnWidth={
          user?.companyAdmin
            ? "11% 13% 13% 12% 13% 11% 13% 8%"
            : "12% 15% 13% 16% 16% 16% 8%"
        }
        setsnackOpen={setsnackOpen}
        fetchDataCallback={fetchDataCallback}
        apiUrl={approvalUrl}
        viewheaders={viewheaders}
        viewPage={PurchaseGoodsView}
      />
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default GoodsService;
